var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn-card",
      class: _vm.btnColor,
      attrs: { type: "button" },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        }
      }
    },
    [
      _c("i", { staticClass: "fa", class: _vm.faName }, [
        _c("span", { staticClass: "btn-card__counter" }, [
          _vm._v(
            _vm._s(_vm.prefix) +
              _vm._s(
                _vm.format !== null ? _vm.format(_vm.counter) : _vm.counter
              )
          )
        ])
      ]),
      _vm._v(" "),
      _c("span", [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ca05368", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca05368","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/ButtonCard.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0ca05368","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/ButtonCard.vue
// module chunks = 0